module.exports = __webpack_public_path__ + "img/hr-pipe-straight-horizontal.b853a37f.png";